import AbstractField from "./AbstractField";

export default class InputField extends AbstractField {
    isInputField = true;
    dimensionInput = false;
    idValue = null;

    label(text) {
        this.labelText = text;
        return this;
    }

    attribute(attribute) {
        this.attributeValue = attribute;
        if (!this.idValue) {
            this.idValue = attribute;
        }
        return this;
    }

    id(id) {
        this.idValue = id;
        return this;
    }

    dimension() {
        this.dimensionInput = true;
        return this;
    }

    input(func) {
        this.initialized
            ? this.inputElement.input(func)
            : this.inputFunction = func;
        return this;
    }

    populate(element) {
        this.populateFunction(element, this.inputElement);
    }

    make() {
        this.field = this.p.createDiv();
        this.labelDiv = this.p.createDiv(this.labelText)
            .parent(this.field)
            .class('input-label');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.applyClasses();
        this.applyStyles();

        this.inputElement = this.dimensionInput
            ? this.p.createInput(0, 'float')
            : this.p.createInput('')
        this.inputElement.parent(this.field)
            .class('input-text')
            .id(this.idValue)
            .input(() => this.inputFunction ? this.inputFunction() : this.setValue());
        this.setFocusAndBlurActions();

        if (this.dimensionInput) {
            this.unit = this.p.createSpan(" (m)").parent(this.labelDiv);
            this.units.push(this.unit);
        }
        this.initialized = true;
        return this;
    }

    value(value) {
        if (value === undefined) {
            return this.getValue();
        }
        this.inputElement.value(value);
        return this;
    }

    setValue() {
        let value = this.getValue();
        if (value == 0) {
            return;
        }
        if (this.selection.selected) {
            let currentElement = this.getTab('info').currentElement;
            this.selection.setValue(value, this.attributeValue, currentElement);
        } else {
            this.makeSticky();
        }
    }

    makeSticky() {
        this.tools.currentTool.makeSticky(this);
        this.inputElement.style('border', '2px solid green');
    }

    focus() {
        this.inputElement.elt.focus();
    }

    getValue() {
        return this.parse(this.inputElement.value());
    }

    setFocusAndBlurActions() {
        this.inputElement.elt.onfocus = () => {
            this.enableHotKeys = false
            this.getTab('info').activeInput = this.inputElement;
        };
        this.inputElement.elt.onblur = () => {
            this.enableHotKeys = true
            let activeInput = this.getTab('info').activeInput;
            this.getTab('info').activeInput = activeInput == this.inputElement
                ? null
                : activeInput;
        };
    }

    parse(value) {
        if (!this.dimensionInput) {
            return value;
        }
        value = parseFloat(value.replace(',', '.')) || 0;
        value = this.settings.metric ? value : value * 0.3048;
        return value * 100;
    }

    reset() {
        this.inputElement.value('');
    }
}
